import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { themeGet } from '@lightspeed/flame/Core';
import { Dropdown } from '@lightspeed/flame/Dropdown';

import { Theme } from 'pages/views/devices/device.styles';

export const UnstyledButton = styled(Button)`
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  padding: 0;

  &:not(:focus),
  &:focus,
  &:hover,
  &:active {
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
  }
`;

export const StyledDropdown = styled(Dropdown)<Theme>`
  min-height: 0px;
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  padding: 0;
  color: ${themeGet('colors.secondary')};

  &:not(:focus),
  &:focus,
  &:hover,
  &:active {
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
    color: ${themeGet('colors.secondary')};
  }

  & svg {
    fill: ${themeGet('colors.secondary')};
  }
`;
